import React from 'react';
import { Container, Typography, Grid, Card, CardContent, Box, Divider } from '@mui/material';

const directors = [
  {
    name: 'Mr. Sudhakar Reddy Gurijala',
    position: 'Managing Director',
    company: 'Shilpaa Electrical Infra Tech (India) Limited',
    bio: 'Mr. Sudhakar Reddy Gurijala is the Managing Director of Shilpaa Electrical Infra Tech (India) Limited, a leading name in high-voltage electrical infrastructure projects across India. With over 25 years of experience, he transformed the company from a proprietorship into a private limited entity, establishing its reputation for quality, innovation, and reliability. He began his career with the Andhra Pradesh Electricity Board and holds a B.A. degree, bringing strong leadership and strategic vision to the organization.',
  },
  {
    name: 'Ms. Sailaja Gurijala',
    position: 'Director – Operations',
    company: 'Shilpaa Electrical Infra Tech (India) Limited',
    bio: 'Ms. Sailaja Gurijala is the Director of Operations at Shilpaa Electrical Infra Tech (India) Limited, where she leads the company’s operational strategies with a focus on efficiency, scalability, and precision. Under her leadership, the company has expanded from a single-state operation to a multi-state leader in high-voltage electrical infrastructure. Her expertise in operational frameworks, project coordination, and quality assurance has driven the company’s success, including recognition as a top A-grade electrical contractor for projects exceeding 33kV',
  },
  {
    name: 'Mr. Dinesh Reddy Attunuri',
    position: 'Board of Director',
    company: 'Shilpaa Electrical Infra Tech (India) Limited',
    bio: 'Mr. Dinesh Reddy Attunuri serves on the Board of Directors at Shilpaa Electrical Infra Tech (India) Limited, contributing to the company’s strategic direction and long-term vision.He holds a Master of Science in Telecommunications Systems Management – Networking from Northeastern University, USA, and a Bachelor of Engineering in Electronics and Communications from Osmania University, India.With experience spanning financial strategy and operational planning since 2013, Mr. Attunuri brings valuable insight and oversight to support the company’s growth and governance in the electrical infrastructure sector.',
  },
  {
    name: 'Ms. Kotla Lalitha',
    position: 'Board of Director',
    company: 'Shilpaa Electrical Infra Tech (India) Limited',
    bio: 'Ms. Kotla Lalitha is an Board of Director with a strong commitment to corporate governance and ethical leadership. With extensive experience in regulatory compliance and board advisory, she brings clarity and direction to strategic decision-making. Her thoughtful perspective and integrity-driven approach support the company’s long-term vision and operational transparency. Ms. Lalitha plays a crucial role in enhancing governance practices and ensuring the organization continues to meet the highest standards of accountability and performance.',
  },
  {
    name: 'Mr. Vittal Grandhi',
    position: 'Independent Director',
    company: 'Shilpaa Electrical Infra Tech (India) Limited',
    bio: 'Mr. Vittal Grandhi is a distinguished Chartered Accountant with over 25 years of dedicated practice, specializing in corporate finance, risk management, regulatory compliance, and business advisory services. He brings deep expertise in financial analysis, strategic financial planning, and stakeholder engagement, making him a trusted advisor to organizations across sectors. Mr. Grandhi is certified in forensic accounting, anti-money laundering (AML), Corporate Social Responsibility (CSR), and Business Responsibility and Sustainability Reporting (BRSR). These credentials underscore his strong foundation in governance and ethical practices. With a holistic understanding of financial and regulatory landscapes, he contributes meaningfully to boardroom deliberations, offering valuable insights that support sustainable growth and sound decision-making.',
  },
  {
    name: 'Ms. Deepa Gusain',
    position: 'Independent Director',
    company: 'Shilpaa Electrical Infra Tech (India) Limited',
    bio: 'Ms. Deepa Gusain is an Independent Director and a qualified Company Secretary with over a decade of experience in corporate governance and compliance. She holds a B.Com (Hons) from Delhi University and an M.Com from IGNOU. She currently serves on the boards of Kapila Krishi Udyog Limited and Reward Pixel Technologies. Her previous roles include compliance leadership at Lakshmi Finance, Fincare Business Services (during its merger with AU Small Finance Bank), and The Leela Ambience Hotels, offering deep expertise across finance, hospitality, and manufacturing sectors.',
  },
];

export default function BoardOfDirectors() {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      {/* Header Section */}
      <Box sx={{ mb: 6, textAlign: 'center' }}>
        <Typography 
          variant="h3" 
          component="h1" 
          gutterBottom
          sx={{ 
            fontWeight: 700, 
            color: '#BF0A30',
            textTransform: 'uppercase'
          }}
        >
          Board of Directors
        </Typography>
        <Divider sx={{ width: 100, height: 4, mx: 'auto', mb: 3, backgroundColor: '#BF0A30', borderRadius: 2 }} />
        <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto' }}>
          Our leadership team brings decades of industry experience and a shared vision for innovation and excellence in electrical infrastructure solutions.
        </Typography>
      </Box>

      {/* Directors Grid */}
      <Grid container spacing={4}>
        {directors.map((director, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card 
              sx={{ 
                height: '100%',
                boxShadow: 3,
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: 6,
                }
              }}
            >
              <CardContent sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant="h5" component="h2" fontWeight="bold" color="#BF0A30">
                  {director.name}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                  {director.position}
                </Typography>
                <Typography variant="subtitle2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                  {director.company}
                </Typography>
                <Divider sx={{ width: 50, height: 3, my: 2, backgroundColor: '#BF0A30', borderRadius: 2 }} />
                <Typography variant="body1" sx={{ mt: 1 }}>
                  {director.bio}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}